var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_2952)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_2952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_2952)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.28244 -1.91644L10.6667 6.14335V-1.33333H17.3334V6.14335L29.2825 -1.91644L30.7737 0.294324L21.3263 6.66667H28V13.3333H21.3263L30.7737 19.7057L29.2825 21.9165L17.3334 13.8567V21.3333H10.6667V13.8567L-1.28244 21.9165L-2.77362 19.7057L6.67377 13.3333H2.95639e-05V6.66667H6.67377L-2.77362 0.294324L-1.28244 -1.91644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.668 6.33219L31.3333 -2",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0128 13.6975L31.3666 21.3503",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00555 6.31046L-3.83746 -1.67099",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29006 13.6049L-3.83746 22.3105",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12H12V20H16V12H28V8H16V0H12V8H0V12Z",
    fill: "#E6273E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_2952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/gb-flag.efbc0ef55bf0631cd037d898169cb925.svg";
export { ForwardRef as ReactComponent };